/* Toprank "Removed — Undo" toast (design "Cart Drawer.html" .toast).
   A capture-phase listener stashes the line payload from the Remove button's
   data-tl-undo attribute (set in snippets/cart-drawer.liquid) before the
   theme's Alpine removeItem() re-renders the drawer, then offers a 4s Undo
   that re-adds the identical line via /cart/add.js and refreshes the drawer
   through the xMiniCart store. The toast element is built once and appended
   to <body>, so drawer re-renders never touch it. */
(function () {
  'use strict';

  var pending = null;
  var hideTimer = null;
  var toast = null;
  var msgEl = null;

  function ensureToast() {
    if (toast) return;
    toast = document.createElement('div');
    toast.className = 'tl-toast';
    toast.setAttribute('role', 'status');
    msgEl = document.createElement('span');
    msgEl.className = 'tl-toast-msg';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tl-toast-undo';
    btn.textContent = 'Undo';
    btn.addEventListener('click', undo);
    toast.appendChild(msgEl);
    toast.appendChild(btn);
    document.body.appendChild(toast);
  }

  function show(msg) {
    ensureToast();
    msgEl.textContent = msg;
    /* force a restart of the transition when a second remove follows quickly */
    toast.classList.remove('show');
    void toast.offsetWidth;
    toast.classList.add('show');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, 4000);
  }

  function hide() {
    if (toast) toast.classList.remove('show');
  }

  function undo() {
    if (!pending) { hide(); return; }
    var line = pending;
    pending = null;
    hide();
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: line.id, quantity: line.quantity, properties: line.properties || {} }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (window.Alpine && window.Alpine.store('xMiniCart')) window.Alpine.store('xMiniCart').reLoad();
        if (window.Alpine && window.Alpine.store('xCartHelper')) {
          window.Alpine.store('xCartHelper').currentItemCount += line.quantity;
        }
      })
      .catch(function () { /* cart state unchanged — nothing to roll back */ });
  }

  /* capture phase: read the payload before Alpine's removeItem mutates the cart */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-tl-undo]');
    if (!btn) return;
    try {
      pending = JSON.parse(btn.getAttribute('data-tl-undo'));
    } catch (err) {
      pending = null;
      return;
    }
    show((pending.title || 'Item') + ' removed');
  }, true);
})();
